import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { getJobsApi } from "../../store/actions";
import { scrollToTop } from "../../utils/scrollToTop";
import CareerBenefitsSection from "./components/CareerBenefitsSection";
import CareerCtaSection from "./components/CareerCtaSection";
import CareerHeaderSection from "./components/CareerHeaderSection";
import CareerHowWeWorkSection from "./components/CareerHowWeWorkSection";
import CareerLifeSection from "./components/CareerLifeSection";
import CareerOpenRolesSection from "./components/CareerOpenRolesSection";
import CareerStorySection from "./components/CareerStorySection";
import SiteFooter from "../../components/layout/SiteFooter";

const Careers = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (page, limit) => {
    setLoading(true);
    try {
      const params = {
        companyName: "Utiva",
        page,
        limit,
      };

      const response = await getJobsApi(params);
      setJobs(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!window.location.hash) {
      scrollToTop();
    }
    fetchData(1, 100);
  }, []);

  useEffect(() => {
    if (!window.location.hash) return;
    // Give the page a moment to finish laying out before jumping to the
    // anchored section — a same-tick scroll can land short since images
    // and the job cards below (loaded async) haven't taken their final
    // height yet. Re-runs once the jobs finish loading so #roles lands
    // correctly even if the job cards shift the layout.
    const timer = window.setTimeout(() => {
      document
        .querySelector(window.location.hash)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 300);
    return () => window.clearTimeout(timer);
  }, [loading]);

  return (
    <div>
      <Helmet>
        <title>Utiva | Careers</title>
      </Helmet>

      <CareerHeaderSection openRolesCount={jobs?.length} />

      <CareerStorySection />

      <CareerOpenRolesSection loading={loading} jobs={jobs} />

      <CareerLifeSection />

      <CareerHowWeWorkSection />

      <CareerBenefitsSection />

      <CareerCtaSection />

      <SiteFooter />
    </div>
  );
};

export default Careers;
